const projects = {
  addSubproject: 'Add a subproject',
  allProjects: 'All Projects',
  archivedProjects: 'Archived Projects',
  archiveExclusiveRelated: 'Also archive tasks and objectives that belong only to this project',
  archiveExclusiveRelatedHelp: 'Tasks and objectives that are also linked to another project stay unchanged.',
  archiveProject: 'Archive project',
  archiveProjectTitle: 'Archive this project?',
  cancelledProjects: 'Cancelled Projects',
  completeProjects: 'Complete Projects',
  createAProject: 'Create a Project',
  noParentProject: 'None',
  noProjectsToDisplay: 'No projects to display',
  ongoingProjects: 'Ongoing Projects',
  parentProject: 'Parent project',
  project: 'Project',
  projectCreated: 'Created the project',
  projectDeleted: 'Deleted the project',
  projectHistoryAssigneeCleared: 'Assignee cleared',
  projectHistoryAssigneeSet: 'Assignee set to {{assignee}}',
  projectHistoryDeadlineCleared: 'Deadline cleared',
  projectHistoryDeadlineSet: 'Deadline set to {{date}}',
  projectHistoryParentCleared: 'Parent project cleared',
  projectHistoryParentSet: 'Parent project set to {{project}}',
  projectHistoryStartDateCleared: 'Start date cleared',
  projectHistoryStartDateSet: 'Start date set to {{date}}',
  projects: 'Projects',
  projectsDueForThisWeek: 'Projects Due for this Week',
  projectsDueForToday: 'Projects Due for Today',
  projectUpdated: 'Updated the project',
  projectUpdatedFields: 'Updated {{fields}}',
  xSelectedProjects_one: '{{count}} selected project',
  xSelectedProjects_other: '{{count}} selected projects',
  youHaveNoOverdueProjects: 'You have no overdue projects.',
  youHaveXOverdueProjects_one: 'You have {{count}} overdue project.',
  youHaveXOverdueProjects_other: 'You have {{count}} overdue projects.',
};

export default projects;
